import React from 'react';

import * as Style from './style.module.scss';
import { PillTone } from './tones';

const toneClassName: Record<PillTone, string> = {
    neutral: Style.neutral,
    info: Style.info,
    success: Style.success,
    warning: Style.warning,
    danger: Style.danger,
    primary: Style.primary,
    secondary: Style.secondary
};

type Props = {
    label: string;
    tone: PillTone;
    tooltipLabel?: string;
};

const StatusPill: React.FC<Props> = ({ label, tone, tooltipLabel }) => (
    <span className={`${Style.pill} ${toneClassName[tone]}`} title={tooltipLabel}>
        {label}
    </span>
);

export default StatusPill;
